<template>
  <div>

    <ValidationObserver ref="form" @submit.prevent="formValidate()">
        <form class="form form--signup" @submit.prevent="formValidate" v-if="!sent">

          <div>
            <label for="field-signup">Email</label>
            <validation-provider ref="fr-email" name="Email" rules="required|email" v-slot="{ errors }">
              <input
                id="field-signup"
                type="text"
                class="form-control"
                name="email"
                v-model="fieldEmail"
                data-lpignore="true"
              >
              <span class="text-danger" v-html="errors[0]"></span>
            </validation-provider>
          </div>
          <div>
            <button type="submit" class="btn btn-outline-light" :class="formProgress ? 'btn-loading' : ''"><span>Get more</span></button>
          </div>

      </form>
      <transition name="fade">
        <div ref="newsletter-message" class="form form--signupmessage" v-if="sent">
          <span v-text="sent.title"></span>
          <div v-html="sent.text"></div>
        </div>
      </transition>
    </ValidationObserver>

  </div>
</template>

<script>

  import Vue from 'vue'
  // import { VueReCaptcha } from 'vue-recaptcha-v3'
  import jump from 'jump.js'
  import FormInstance from '../mixins/FormInstance'

  export default {

      name: 'newsletter-form',

      mixins: [ FormInstance ],

      data() {

          return {

              // fields
              fieldEmail: ''

          }

      },

      methods: {

          formProceed(token) {

            var data = new FormData();

            data.append('t', token);
            data.append('email', this.fieldEmail);

            axios.post(this.supplies.link, data).then(response => {

              this.formProgress = false;

              if(response.data.errors) {

                this.errorHandler(response.data.errors, 'fr-email');

              } else {

                this.sent = response.data.message;

                this.$nextTick(() => {

                  jump(this.$refs['newsletter-message'], {
                    duration: 600,
                    offset: -($('.g.g--header').height() + 20)
                  });

                });

              }

            }, error => {

              this.formProgress = false;

              this.errorHandler({ email: 'Request has failed, please try again.' }, 'fr-email'); // error

            });

          }

      }

  }

</script>
